import { render } from "./CounterReport.vue?vue&type=template&id=3faa988e"
import script from "./CounterReport.vue?vue&type=script&lang=js"
export * from "./CounterReport.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__